<template>
    <div class="row col s12 vert-offset-top-1">
        <div v-show="component == '' " class="col s12 l10 offset-l1">
            <div class="card grey lighten-4 col s12 vert-offset-top-1 padding-top-half ">
                <div class="card-content col s12 left-align">
                    <h5>What type of Location/Establishment are you reporting?</h5>
                    <div class="card-content col s12 flow-text">

                        <div class="col s12 m10 offset-m1 padding-top-half padding-bottom-half no-padding flow-text grey-border border-bottom-1 border-lighten-2 padding-bottom-1" >
                            <form @submit.prevent="" class="row col s12 no-padding left-align" >
                                <p v-for="(item, index) in items"
                                   :key="index">
                                    <label>
                                        <input type="radio" name="other" :value="item.key"
                                               :key="index" @click="selectItem(index)" />
                                        <span v-html="item.name" class="bold black-text"></span>
                                    </label>
                                </p>
                            </form>
                          <ul>
                            <li v-show="(typeof items === 'undefined' || items === null || items.length=== 0) && data_loaded === true" >
                              network error, check connection and try again!
                            </li>
                          </ul>
                        </div>

                    </div>
                    <div class="col s4 offset-s8 vert-offset-top-1">
                        <button type="submit" @click="loadSelectLocation" id="submit_button" class="btn btn-large grey darken-2 white-text col s12" :disabled='counter <= 0' >
                            next
                        </button>

                    </div>
                </div>

            </div>
        </div>
        <component v-bind:is="component"></component>
    </div>
</template>

<script>
    import LocationSelect from "@/components/LocationSelect"
    import http from "../http-common"
export default {
    components: {
        'LocationSelect':LocationSelect
    },
    name: "Other",


data () {
    return{
        enableDisable: true,
        component:"",
        items : [],
        selected_item : [],
        counter : 0,
      data_loaded: false
    }
},
created()
{
        this.getTypes();
},
methods:{
        
        loadSelectLocation: function()
        {
            this.$store.commit('SET_SELECTED_LOCATION_TYPES', this.selected_item);
            this.component = 'LocationSelect';
        },
    selectItem: function (_index)
    {
        var _selected_item = this.items[_index];
        if(typeof  _selected_item === "undefined" || _selected_item === null)
        {
            return false;
        }

        this.selected_item = _selected_item.key;
        this.counter++;
    },
    getTypes: function() {
      this.data_loaded = false;
        this.$store.dispatch("START_PROCESSING");
        return new Promise(resolve => {
            http({
                url: "/locationtypes/list/select",
                data : {
                    outlets : this.outlets,
                },
                method: "POST",
                timeout: 30000 })
                .then(resp => {

                  this.data_loaded = true;
                   //console.log("Response:" + JSON.stringify(resp));
                   //console.log("token:" + JSON.stringify(resp.data));

                    this.items = resp.data.data;
                    this.$store.dispatch("STOP_PROCESSING");
                   //console.log("offences: " + JSON.stringify(this.outlets));

                    resolve(resp);
                })
                .catch(response => {
                  this.data_loaded = true;
                   //console.log("ErrResponse: " + JSON.stringify(response));
                    this.$store.dispatch("STOP_PROCESSING");
                    this.$store.dispatch("GET_MESSAGES", response.data.messages);

                });
        });
    },

},

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
